module.exports = __webpack_public_path__ + "img/wenli.1c180036.png";